module.exports = __webpack_public_path__ + "img/1F1F0-1F1ED.a7ae34d7.svg";